import convertImgixPropsToQueryParams from './convertImgixPropsToQueryParams';

// A bare imgix url serves the full original. A signed one (s=) is left alone,
// since any added param breaks the signature.
const withImgixWidth = (src, width) => {
  if (!src || /[?&]s=/.test(src)) {
    return src;
  }

  return src.includes('?')
    ? `${src}&w=${width}`
    : convertImgixPropsToQueryParams({ width }, src);
};

export default withImgixWidth;
